const golfData = {
    text : [
        "La recepción les informará de las tarifas de los campos y les reservará su “teee time”.",
        "El hotel le facilita una consigna especial para el equipaje de golf ubicada en el lobby.",
        "Nuestros húespedes se podrán beneficiar de descuentos en greenfees de diversos campos de golf."
    ]
};

export default golfData;